import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_FOLLOWUPS = "SET_FOLLOWUPS";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

function setFollowUps(followUps) {
  return {
    type: SET_FOLLOWUPS,
    payload: followUps,
  };
}

export function createFollowUp(token, data, callback) {
  return async () => {
    try {
      const response = await axios.post(`${HOST_URL}/follow-ups`, data, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function getFollowUps(token, request, callback) {
  return async () => {
    try {
      const response = await axios.get(
        `${HOST_URL}/follow-ups?request=${request}&limit=100`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      callback(response.data.data);
    //   await dispatch(setFollowUps(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

// Latest follow-ups of all requests, to show the last reminder in lists
export function getLatestFollowUps(token, callback) {
  return async () => {
    try {
      const response = await axios.get(`${HOST_URL}/follow-ups?limit=100`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });
      callback(response.data.data || []);
    } catch (error) {
      console.log(error.response?.data?.message || error.message);
      callback([]);
    }
  };
}
